// Helpers & Constants -------------------------------------------------------------------
import { GigyaErrorStatus } from '@helpers/constants/gigya';
//------------------------------------------------------------------------------

export const ProfileKindInfo = (t, type) => {
  const ProfileKindDetails = {
    PersonalInfo: {
      title: t('profile_AccountTitle'),
      screenIdentified: 'gigya-update-profile-screen',
      shouldAuthenticate: true,
    },
    Password: {
      title: t('profile_ChangeYourPassword'),
      screenIdentified: 'gigya-change-password-screen',
      parsedError: ({ errorCode, errorMessage }) =>
        errorCode === GigyaErrorStatus.InvalidLoginID
          ? 'Invalid current password. Please try again.'
          : errorMessage,
    },
  };
  return ProfileKindDetails[type];
};
